<script lang="ts" setup>
import { useLocaleStore, useLocaleStoreRef } from '@/stores';
import { DropdownComp } from '@/components';
import { $tm } from '@/locize';
import { DropdownItemButton } from '@/objects';

const { locales, setLocale } = useLocaleStore();
const { locale } = useLocaleStoreRef();

/**
 * Set the currentlanguage
 * @param language
 */
function setLanguage(language: string) {
    /**
     * Refresh the translations in the current view
     * all elements with the data-i18n attribute will be updated
     */
    document.querySelectorAll('[data-i18n]').forEach((element) => {
        // TODO: Doublecheck that placeholders is not supported out of the box
        if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
            element.placeholder = $tm(element.placeholder);
        }
    });

    setLocale(language);
}

const dropdownItems = locales.map((l) =>
    DropdownItemButton.create({
        action: () => setLanguage(l.Locale),
        icon: 'fi-' + l.Iso2,
        translationkey: l.Name,
    }),
);
</script>

<template>
    <DropdownComp
        class="language-selector"
        :buttonType="'Secondary'"
        :icon="'fi-' + locale.Iso2"
        iconPosition="left"
        :dropdownItems="dropdownItems"
        :translationkey="locale.Locale"
    />
</template>
